// このファイルは設計書（231 プログラム生成元ドキュメント）の表から生成した。手で直すときは設計書と突き合わせること。
// 02 バックエンド設計書 2.6.1（エラー）・2.6.2／03 4.2（完了。サーバーは返さない）

export const ERROR_CODE_DEFINITIONS = {
  AUTH_001: { http_status: 403, message: 'この操作を実行する権限がありません。管理者にお問い合わせください。' },
  AUTH_002: { http_status: 401, message: 'セッションが無効になりました。再度ログインしてください。' },
  AUTH_003: {
    http_status: 429,
    message: 'アカウントが一時的にロックされています。しばらく待ってから再度お試しください。',
  },
  AUTH_004: { http_status: 401, message: 'トークンの有効期限が切れています。再度ログインしてください。' },
  AUTH_005: {
    http_status: 401,
    message: '認証コードが正しくありません。メールに記載されたコードを正確に入力してください。',
  },
  AUTH_006: { http_status: 403, message: 'このアカウントは現在利用できません。管理者にお問い合わせください。' },
  AUTH_007: { http_status: 401, message: '認証コードの有効期限が切れています。コードを再送信してください。' },
  AUTH_EMAIL_NOT_VERIFIED: {
    http_status: 403,
    message: 'メールアドレスが未検証です。下の「メールアドレスを検証する」ボタンをクリックしてください。',
  },
  AUTH_USER_NOT_FOUND: {
    http_status: 404,
    message: 'このメールアドレスは登録されていません。管理者にお問い合わせください。',
  },
  VALIDATION_001: { http_status: 400, message: '入力内容に不備があります。各項目をご確認ください。' },
  NOT_FOUND_001: { http_status: 404, message: '指定されたデータが見つかりませんでした。' },
  DYNAMODB_001: {
    http_status: 500,
    message: 'データベースエラーが発生しました。しばらく待ってから再度お試しください。',
  },
  INTERNAL_ERROR: { http_status: 500, message: 'システムエラーが発生しました。しばらく待ってから再度お試しください。' },
  COMPANY_001: { http_status: 409, message: '顧客コードが既に使用されています。' },
  COMPANY_002: { http_status: 500, message: '企業情報の更新に失敗しました。' },
  COMPANY_003: { http_status: 500, message: '企業の削除に失敗しました。' },
  INDIVIDUAL_001: { http_status: 409, message: '顧客コードが既に使用されています。' },
  INDIVIDUAL_002: { http_status: 500, message: '個人事業主情報の更新に失敗しました。' },
  INDIVIDUAL_003: { http_status: 500, message: '個人事業主の削除に失敗しました。' },
  USER_001: { http_status: 409, message: 'メールアドレスが既に使用されています。' },
  USER_002: { http_status: 500, message: 'ユーザー情報の更新に失敗しました。' },
  USER_003: { http_status: 500, message: 'ユーザーの削除に失敗しました。' },
  FILE_001: { http_status: 500, message: 'ファイルのアップロードに失敗しました。' },
  FILE_002: { http_status: 500, message: 'ファイルのダウンロードに失敗しました。' },
  FILE_003: { http_status: 400, message: 'ファイルの形式が正しくありません。' },
  FILE_004: { http_status: 400, message: 'ファイルサイズは10MB以下にしてください' },
  IMPORT_001: { http_status: 400, message: 'CSVファイルの形式が正しくありません。' },
  IMPORT_002: { http_status: 500, message: 'インポート処理中にエラーが発生しました。' },
  IMPORT_003: { http_status: 422, message: '重複するデータが含まれています。' },
  IMPORT_004: { http_status: 422, message: '取込できる行数（10,000行）を超えています。' },
  IMPORT_005: { http_status: 400, message: '必須の列が対応づけられていません。' },
  EXPORT_001: { http_status: 500, message: 'エクスポートに失敗しました' },
  JOB_001: { http_status: 409, message: '処理がまだ完了していません。しばらく待ってから再度お試しください。' },
  CSRF_001: { http_status: 403, message: '不正な要求のため処理できませんでした。画面を再読み込みしてください。' },
  RATE_001: { http_status: 429, message: '短時間に操作が繰り返されました。しばらく待ってから再度お試しください。' },
  CONFLICT_001: {
    http_status: 409,
    message: '他の利用者が先に更新しました。画面を再読み込みしてから、もう一度操作してください。',
  },
  IDEMPOTENCY_001: {
    http_status: 409,
    message: '同じ操作を処理しています。しばらく待ってから画面を確認してください。',
  },
  IDEMPOTENCY_002: {
    http_status: 422,
    message: '同じ操作キーで異なる内容が送信されました。画面を再読み込みしてください。',
  },
  IDEMPOTENCY_003: { http_status: 400, message: '操作キーがありません。画面を再読み込みしてください。' },
  STATE_001: { http_status: 409, message: '現在の状態ではこの操作はできません。' },
  RELATION_001: { http_status: 422, message: '関連するデータが見つかりません。選び直してください。' },
  RELATION_002: { http_status: 422, message: '使用中のため削除できません。' },
  ROLE_001: { http_status: 422, message: 'システムロールは削除できません' },
  PRICE_001: { http_status: 409, message: '同じ適用開始日の単価変更が既に登録されています。' },
  PRICE_002: { http_status: 422, message: '単価が変更されていません' },
  FILE_005: { http_status: 422, message: '1件に添付できるファイルは20件までです。' },
  FILE_006: {
    http_status: 422,
    message: 'アップロードしたファイルが確認できません。もう一度アップロードしてください。',
  },
  LIST_001: { http_status: 422, message: '対象が多すぎます。絞り込み条件を追加してください。' },
  MAIL_001: { http_status: 503, message: 'メールの送信に失敗しました' },
  MAIL_002: { http_status: 422, message: '送信先のメールアドレスが見つかりません' },
  CONTACT_001: { http_status: 409, message: 'この企業のコンタクトは既にあります。' },
  CHECKLIST_001: { http_status: 409, message: 'デフォルトテンプレートは既に存在します' },
  FORM_001: { http_status: 410, message: 'このフォームの受付は終了しました。' },
  FORM_002: { http_status: 404, message: 'このフォームは現在利用できません。' },
  FORM_003: { http_status: 410, message: 'このフォームは受付上限に達しました。' },
  FORM_004: { http_status: 403, message: '送信元が許可されていません。' },
  // FORM_005 は 5.4 ③（bot 判定）の拒否に使っていた。2026-09-29 に③を廃止して返さなくなった（設計書の表に合わせて残す：インフラ実装メモ X-14）
  FORM_005: { http_status: 403, message: '送信を受け付けられませんでした。時間をおいて再度お試しください。' },
  FORM_006: { http_status: 400, message: 'フォームの定義が大きすぎます。項目数を減らしてください。' },
  // 273：旧PCRMから落ちていた複数回答の許可を戻す（許可しないフォームに同じメールアドレスで 2 回目の回答）
  FORM_007: { http_status: 409, message: 'このフォームには既に回答済みです。' },
  NUMBERING_001: { http_status: 422, message: '採番の上限に達しました。採番ルールの連番桁数を見直してください。' },
} as const;

export type ErrorCode = keyof typeof ERROR_CODE_DEFINITIONS;

/** 完了コード（画面の辞書。API のレスポンスには含めない：02 2.6.2） */
export const COMPLETION_CODE_MESSAGES = {
  COMPANY_CREATED: '企業情報を正常に登録しました。',
  COMPANY_UPDATED: '企業情報を正常に更新しました。',
  COMPANY_DELETED: '企業情報を正常に削除しました。',
  INDIVIDUAL_CREATED: '個人事業主情報を正常に登録しました。',
  INDIVIDUAL_UPDATED: '個人事業主情報を正常に更新しました。',
  INDIVIDUAL_DELETED: '個人事業主情報を正常に削除しました。',
  USER_UPDATED: 'ユーザー情報を正常に更新しました。',
  USER_DELETED: 'ユーザーを正常に削除しました。',
  AUTH_LOGOUT: '正常にログアウトしました。',
  FILE_UPLOADED: 'ファイルを正常にアップロードしました。',
  FILE_DELETED: 'ファイルを正常に削除しました。',
  IMPORT_SUCCESS: 'データのインポートが正常に完了しました。',
} as const;

export type CompletionCode = keyof typeof COMPLETION_CODE_MESSAGES;
